import { HttpRequest } from '@angular/common/http';

export const showLoadingHelper = (req: HttpRequest<any>) => {
  if (window.location.pathname.includes('administration') || req.url.includes('?sort')) {
    return true;
  }
  if (
    (req.url.includes('/lov') && !req.url.includes('kpi/lov')) ||
    req.url.includes('/quick-search') ||
    req.url.includes('/personas/existing/') ||
    req.url.includes('personas/import?query=') ||
    (req.url.includes('/sections/operations/subsections/kpi') && (req.method == 'POST' || req.method == 'OPTIONS'))
  ) {
    return false;
  }
  if (
    req.url.includes('personas') &&
    !req.url.includes('subsection') &&
    !req.url.includes('personas/import?uid=') &&
    (req.method == 'POST' || req.method == 'OPTIONS')
  ) {
    return false;
  }
  return true;
};
